import { useParams } from "react-router-dom";
import RecipeEditor from "./RecipeEditor";

export default function RecipeEdit() {
  const { id } = useParams();

  return <RecipeEditor mode="edit" recipeId={id} />;
}